import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import api from "../api";
import "../Styles/SignUp.css";
import { toast } from "react-toastify";
import { showToast } from "../Components/PopupMessage.jsx";
import api from "../Api.js"

const SignUp = () => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(Array(4).fill(""));
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [timer, setTimer] = useState(60);
  const [isActive, setIsActive] = useState(false);

  const navigate = useNavigate();

  // ✅ Send OTP
  const handleSendOtp = async () => {
    if (phone === "") {
      toast.warning("Please enter your phone number");
      return;
    }
    // if (!/^[0-9]{10}$/.test(phone)) {
    //   toast.warning("Please enter a valid 10-digit phone number");
    //   return;
    // }

    try {
      setLoading(true);
      setError("");
      const response = await api.post(
        `/send-otp`,
        { email: phone },
        // ✅ body data
        {
          headers: {
            " Content-Type": "application/json", // ✅ wrap in quotes
          },
        }
      );


      if (response.data.status === true) {
        showToast("OTP sent Successfully..", "success");
        console.log(response.data);
        setStep(2);
        setTimer(60);
        setIsActive(true);
        
        // alert(`Please check your Email for OTP`);
      }


    } catch (err) {
      setError("Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Verify OTP
const handleVerifyOtp = async () => {
  try {
    setLoading(true);
    setError("");
    const otpString = otp.join("");
    const otpNumber = Number(otpString);

    if (!otpNumber || otpString.length !== 4) {
      setError("Invalid OTP. Please enter a valid 4-digit OTP.");
      return;
    }
    console.log(otpString);
    console.log(phone);

    const response = await api.post(
      "/verify-otp",
      { email: phone, otp: otpString },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.status === true) {
      console.log("Signup successful:", response.data);
      localStorage.setItem("accessToken", response.data.token);
      localStorage.setItem("customer", JSON.stringify(response.data.customer));

      showToast("Logged in successfully", "success");

      // --- Get the redirect URL from query string ---
      const params = new URLSearchParams(window.location.search);
      const redirect = params.get('redirect') || '/';
      
      // --- Force a full page reload to that URL ---
      window.location.href = redirect;
    } else {
      setError(response.data.message || "Invalid OTP. Please try again.");
      showToast("Invalid OTP. Please try again", "warning");
    }
  } catch (err) {
    setError("Invalid OTP. Please try again.");
  } finally {
    setLoading(false);
  }
};

  // ✅ OTP input handling
  const handleOtpChange = (value, index) => {
    if (isNaN(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    console.log(otp);
    if (value !== "" && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "") {
        if (index > 0) {
          const newOtp = [...otp];
          newOtp[index - 1] = "";
          setOtp(newOtp);
          document.getElementById(`otp-${index - 1}`)?.focus();
          e.preventDefault();
        }
      }
    }
  };

  // ✅ Timer countdown
  useEffect(() => {
    let interval = null;
    if (isActive && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
      setIsActive(false);
    }
    return () => clearInterval(interval);
  }, [isActive, timer]);

  // ✅ Resend OTP
  const handleResend = () => {
    handleSendOtp();
    setOtp(Array(4).fill(""));
    setTimer(60);
    setIsActive(true);
  };

  return (
    <div className="SignUp">
      <div className="signup_container">
        <button
  className="signup-close-btn"
  onClick={() => navigate("/")}
>
  ✕
</button>

        <h1>Login</h1>

        {error && <p className="error-text">{error}</p>}

        {step === 1 && (
          <form className="signup_form" onSubmit={(e) => e.preventDefault()}>
            <label>Email Id : </label>
            <input
              type="email"
              placeholder="Enter your Email Id"
              
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
            <button type="button" onClick={handleSendOtp} disabled={loading}>
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>
          </form>
        )}

        {step === 2 && (
          <div className="signup_form">
            <label>Enter OTP</label>
            <div className="otp-inputs">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                  onKeyDown={(e) => handleOtpKeyDown(e, index)}
                />
              ))}
            </div>
            <div className="resend-otp">
              {isActive ? (
                <p>Resend OTP in {timer} sec</p>
              ) : (
                <p
                  type="button"
                  style={{ color: "#79a93b" }}
                  onClick={handleResend}
                >
                  Resend OTP
                </p>
              )}
            </div>
            <button type="button" onClick={handleVerifyOtp} disabled={loading}>
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignUp;
